import React from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../Common/Header';
import axios from 'axios';
import TrirdpartyPage from "../Savings/MakePayments/ThirdPartyTransfer";
import BillPaymentPage from "../Savings/BillPayments/BillPayment";
import STOPayments from "../Savings/StandingOrders/StandingOrder";
import { createContext } from 'react';
import FadeLoader from "react-spinners/HashLoader";
import Modal from 'react-bootstrap/Modal';
import Common from '../Common/CommonAPI';
import moment from 'moment';
import transferImage from "../images/transfer.png"
import ttransferImage from "../images/ttransfer.png"
import ttransferImage2 from "../images/ttransfero.png"
import fdImage from "../images/fd2.png"
import Middle from "./MiddleSection"

import stotransfer from "../images/stotransfer.png"
import stotransfer2 from "../images/stotransfero.png"
import billtransfer from "../images/billcreate.png"
import billtransfer2 from "../images/billcreateo.png"
import fdrates from "../images/fdRates.png"
import fdrates2 from "../images/fdRateso.png"

import hbill from "../images/hbill.png"
import mbill from "../images/mbill.png"

var  initPromises = [];

class Home extends React.PureComponent {
    constructor(props) {
        super(props);
        initPromises.push(this.getInitData());       
        this.state = {           
            RecentTransList:[],
            username:'',
            ThirdTrnsferModal:false,
            BillPaymentModal:false,
            STOModal:false,            
            Loading:true,
            SavingsID:"",
            FromAccountList:[],
            setSelectFromAll:{},
            mouseOver1:0,
        }
    }

    getInitData = ()=>{        
         Common.FromToAccountAPI((results) =>{   
            if( results){  
                this.setState({  
                    FromAccountList:results.data.mapAccountList?results.data.mapAccountList:null,
                    setSelectFromAccountID:results.data.mapAccountList[0].id,
                    setSelectFromAll:results.data.mapAccountList[0],
                });  
                this.GetRecentTransActionsAPI(results.data.mapAccountList[0].id);                         
            }
        });        
    }

     ResponseLoadingModal = ()=> {
        return(
            <Modal
            size="lg"
            centered 
            className="ui-block" show={this.state.Loading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={this.state.Loading}
                />
           
           </Modal>
         )
      }
    componentDidMount(){
        this.GetHomeData();        
    }


    GetRecentTransActionsAPI(id){
        this.setState({           
            Loading   :true,  
          }) 
         Common.RecentTransactions({SavID:id},(results) =>{
            if(results){
                this.setState({
                    RecentTransList:results.accountStatement.accountTransactionList,
                    Loading   :false,  
                  }) 
            }else{
                this.setState({                   
                    Loading   :false,  
                  })
            }
          })
    }
    GetHomeData(){
        
        if(sessionStorage.getItem("CheckUserValid")!=null && sessionStorage.getItem("NIC")===null){           ;
            var ValidUser  = JSON.parse(sessionStorage.getItem("CheckUserValid")).checkValidUser;            
 
            if(ValidUser==="NotValid"){
              this.setState({
               Loading:false,
               NotValidUser:true,
             });
            }
          }          
            
        var getUD = JSON.parse(sessionStorage.getItem("NIC"));

        Common.homeApi((results) =>{

          this.setState(Object.assign({           
           showProgress: results.success?true:false,
              //isLogin:true,
              Loading:false,
          },results));
                if( results){
                    this.setState({
                      FinalFDRate1:results.atMaturity,                   
                      Totalpawning:results.pawnLoansOutstanding,
                      totalDepositAmount:results.totalFDDepositAmount,
                      SavingavialableBalTotal:results.totalSavingsAccountBalances,
                      Loading:false,
                               
                    })
                  }
            });
       }

     SelectFromOnChange = (event) => {

        var passValFrom = JSON.parse(event.target.value);
        this.setState({
            setSelectFromAll:JSON.parse(event.target.value),
            setSelectFromAccount:passValFrom.accountNo?passValFrom.accountNo:null,
            setSelectFromAccountID:passValFrom.id?passValFrom.id:null,
            setFromAccountAvailableBalance:passValFrom.avialableBalance?passValFrom.avialableBalance:null,
        })
        this.GetRecentTransActionsAPI(passValFrom.id);                 
     }

    TrirdToggleModal = () => {
        this.setState({ ThirdTrnsferModal: !this.state.ThirdTrnsferModal })
        }
    BillPaymentToggleModal = () => {
        this.setState({ BillPaymentModal: !this.state.BillPaymentModal })
    }
    STOToggleModal = () => {
        this.setState({ STOModal: !this.state.STOModal })
    }

    async fdRates(){
        const url = 'https://www.senfin.com/personal.html#FDTag';
        window.open(url, '_blank');  
    }
    
    render(){
      
        if(this.state.NotValidUser){
            return (
            <div className="notValid-div">
              <div style={{marginTop:'20%'}}>
                <p className="notValid-text" >Service Temporarily Unavailable</p>
              </div>
             <Link to="/">
              <button
               onClick={()=>this.setState({logout:true})}
               className="w3-button notValid-btn w3-round-large">OK
              </button>
             </Link>
            </div>);
          }else{
        return(
            <> 
                
                {this.ResponseLoadingModal()}
                {this.state.ThirdTrnsferModal?
                <TrirdpartyPage isOpen={this.state.ThirdTrnsferModal} toggle={this.TrirdToggleModal}/>
                :null
                }
                 {this.state.BillPaymentModal?
                <BillPaymentPage isOpen={this.state.BillPaymentModal} toggle={this.BillPaymentToggleModal}/>
                 :null
                }
                {this.state.STOModal?
                <STOPayments isOpen={this.state.STOModal} toggle={this.STOToggleModal}/>
                :null
                }

                <Container fluid>
                    <Row className=''>
                        <Col className='p-0 mt-3'>  
                        {/* <section className='b-color mb-3'>
                            <Container>
                                    <img className="banner-img" src={require('../images/backBanner.PNG')} alt="banner"/>
                            </Container>    
                        </section>                                  */}
                        <Container>                                                  
                        <Row lg={12} className="block mt-1">
                            <Col lg={3} className='rmv-pad' >
                            <div className='d-box'>                                
                                <p className='t-right fontSize'>
                                    Total Fixed Deposits<br/>
                                    <h2>{this.state.totalDepositAmount}</h2>
                                    LKR
                                </p>                                
                            </div>                            
                            </Col>
                            <Col lg={3} className='rmv-pad2'>
                            <div className='d-box d-box1'>                                
                                <p className='t-right fontSize'>
                                    Total Available Savings<br/>
                                    <h2>{this.state.SavingavialableBalTotal}</h2>
                                    LKR
                                </p>                                
                            </div>
                            </Col>
                            <Col lg={3} className='rmv-pad2'>
                            <div className='d-box d-box2'>                                
                                <p className='t-right fontSize'>
                                   Pawning Loans Outstanding<br/>
                                    <h2>{this.state.Totalpawning}</h2>
                                    LKR
                                </p>                                
                            </div>
                            </Col>
                            <Col lg={3} className='rmv-pad3'>
                            <div className='d-box d-box3'>                                
                                <p className='t-right fontSize'>
                                    Lease/ Loans Outstanding<br/>
                                    <h2>0.00</h2>     
                                    LKR                               
                                </p>         
                                             
                            </div>
                            </Col>
                        </Row>
                        </Container> 
                        <Container> 
                        <Row>
                            <Col lg={4} sm={12} className='rmv-pad text-color block' >
                                <Row className='ms-top2'>                                
                                    <div className='d-flex me-auto block-header' >
                                       <h6> QUICK LINKS</h6>
                                    </div>                                
                                </Row>
                                <Row className=''>                                
                                    <div className='t-left fontSize'>                                    
                                    <Button 
                                    onMouseOver={()=>this.setState({mouseOver1:1})}
                                    onMouseOut={()=>this.setState({mouseOver1:0})}
                                     onClick={()=>this.setState({ThirdTrnsferModal:true})} className="home-btn" variant="primary" type="submit">
                                        <div>
                                            <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===1?ttransferImage2:ttransferImage} />
                                            <p className='hbuttonfont'>THIRD PARTY TRANSFER</p>
                                        </div>
                                    </Button>                                    
                                    <Button 
                                    onMouseOver={()=>this.setState({mouseOver1:2})}
                                    onMouseOut={()=>this.setState({mouseOver1:0})}
                                    onClick={() => this.setState({BillPaymentModal:true})} className="home-btn" variant="primary" type="submit">
                                        <div>
                                            <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===2?billtransfer2:billtransfer} />
                                            <p className='hbuttonfont'>MAKE BILL PAYMENTS</p>
                                        </div>
                                    </Button>
                                    <Button 
                                    onMouseOver={()=>this.setState({mouseOver1:3})}
                                    onMouseOut={()=>this.setState({mouseOver1:0})}
                                    onClick={() => this.setState({STOModal:true})} className="home-btn" variant="primary" type="submit">
                                        <div>
                                            <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===3?stotransfer2:stotransfer} />
                                            <p className='hbuttonfont'> CREATE STANDING ORDERS</p>
                                        </div>
                                    </Button>                                   
                                    <Button 
                                    onMouseOver={()=>this.setState({mouseOver1:4})}
                                    onMouseOut={()=>this.setState({mouseOver1:0})}
                                    onClick={()=>this.fdRates()} className="home-btn" variant="primary" type="submit">
                                        <div>
                                            <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===4?fdrates2:fdrates} />
                                            <p className='hbuttonfont'>FIXED DEPOSIT RATES</p>
                                        </div>
                                    </Button>
                                    </div>                                
                                </Row>
                            </Col>
                            <Col lg={5} sm={12} className='rmv-pad3 text-color'>
                                <Row >
                                <div className='d-flex flex-row align-items-center' >                                    
                                    <div className='d-flex me-auto block-header' >
                                        <h6>RECENT TRANSACTIONS</h6>
                                    </div>
                                    <p className='t-width'>Account No</p>                                    
                                    <div >  
                                    <Form.Select size="sm"
                                        value={JSON.stringify(this.state.setSelectFromAll)} 
                                        onChange={this.SelectFromOnChange}
                                        className="form-h2 ">
                                            
                                            {this.state.FromAccountList?this.state.FromAccountList.filter((e)=>e.jointAccountVisibility===true).map((listValue,index)=>{
                                                return (
                                                <option  key={index} value={JSON.stringify(listValue)}>
                                                A/N : {listValue.accountNo} 
                                                </option>)
                                            }):
                                            null
                                            }
                                        </Form.Select>  
                                    </div> 
                                    </div>                                                                
                                </Row>
                                <Row >                                
                                    <Table className='block-top' hover striped responsive>
                                    <thead >
                                        <tr  className='tr'   >
                                            <th className='td-width5 t-left'>Date</th>
                                            <th className='td-width5 t-left'>Description</th>
                                            <th className='td-width5'>In /Out </th>
                                            <th className='td-width'>Current Balance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.RecentTransList.length>0?this.state.RecentTransList.slice(0, 3).map((ListValue,index)=>
                                        {
                                        return(
                                        <tr className='tr'>
                                        <td className='td-width5 t-left'>{moment(ListValue.transactionDate).format('DD/MM/YYYY')}<br/>{moment(ListValue.transactionDateTime).format('hh:mm:ss A')}</td>
                                        <td className='td-width5 t-left'>{ListValue.transactionTypeName} {ListValue.transactionType}</td>
                                        <td className='td-width5'>
                                        {ListValue.moneyIn===0.0?
                                        <div className="tb-text5 ">
                                            <p className="moneyout-p">
                                            {ListValue.moneyOut.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                            </p>                                        
                                        </div>
                                        :
                                        <div className="tb-text5 ">
                                            <p className="moneyin-p">
                                            {ListValue.moneyIn.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                            </p>                                     
                                        </div>
                                        }  
                                        </td>
                                        <td className='td-width'>{ListValue.balance.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                        </tr>
                                        )
                                        
                                        }):null}
                                        
                                    </tbody>
                                    </Table>                            
                                </Row>
                            </Col>
                            <Col lg={3} sm={12} className='rmv-pad3 text-color'>
                                <Row className=''>                                
                                    <p className='t-right '>                                    
                                        <h2>Senior citizens</h2>
                                        Interest for 60 months<br/>
                                        <h2>{this.state.FinalFDRate1}%</h2>
                                    </p>                                 
                                </Row>
                            </Col>
                        </Row>
                        </Container> 
                        </Col>
                    </Row>
                </Container>
            </>
        );
      }
    }
}
export default Home;